import { createApi } from '@reduxjs/toolkit/query/react';
import { DateFormats, formatDate } from '@strata/helper-functions';
import { type TreatmentStatusIndicator } from '@strata/react-status-indicators';

import { TREATMENT_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const treatmentApi = createApi({
    baseQuery: getBaseQuery(TREATMENT_API_URL),
    reducerPath: 'treatmentApi',
    endpoints: (build) => ({
        getTreatmentsForPatient: build.query<
            {
                treatment_id: string;
                product_service_oid: string;
                treatment_status: (typeof TreatmentStatusIndicator.Statuses)[keyof typeof TreatmentStatusIndicator.Statuses];
            }[],
            {
                payerId: string;
                segmentId: string;
                memberId: string;
                memberDateOfBirth: Date;
                memberFirstName: string;
                memberLastName: string;
            }
        >({
            query: ({
                payerId,
                segmentId,
                memberId,
                memberDateOfBirth,
                memberFirstName,
                memberLastName,
            }) => ({
                url: `${payerId}/treatments`,
                params: {
                    segment_id: segmentId,
                    member_id: memberId,
                    patient_dob: formatDate(memberDateOfBirth, DateFormats.HYPHEN_DATE),
                    patient_first_name: memberFirstName,
                    patient_last_name: memberLastName,
                },
            }),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving treatments for member.',
            ),
        }),
    }),
});

export const { useGetTreatmentsForPatientQuery } = treatmentApi;
